import PropTypes from 'prop-types';
import { authorTilePropTypes } from '@Theme/natucare/modules/Authorship/components/AuthorTile/AuthorTilePropTypes';
export const authorshipPropTypes = {
  /**
   * Heading content
   */
  heading: PropTypes.string,
  /**
   * Link - object of label and href
   */
  link: PropTypes.shape({
    label: PropTypes.string,
    href: PropTypes.string
  }),
  /**
   * Array of author's data:  picture, href, role, name, description, verifiedLabel, socials object
   */
  items: PropTypes.arrayOf(PropTypes.shape(authorTilePropTypes))
};